module.exports = __webpack_public_path__ + "img/img12.3c1d487.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/01/img12.png
// module id = 167
// module chunks = 0